import axiosInstance from "../../../api/axiosConfig";

export const getUsers = (params: any) => {
  return axiosInstance.get("/admin/users", {
    params: params,
  });
};

export const deleteUser = (id: string) => {
  return axiosInstance.delete(`/admin/users/${id}`);
};
